// Generated by scripts/optimize-images.mjs after all variants are ready.
export const PUBLIC_IMAGE_ORIGINALS = [
  "/images/blog-autonomous-acreage.jpg",
  "/images/blog-buying-guide.jpg",
  "/images/blog-commercial-work.jpg",
  "/images/blog-flail-ground.jpg",
  "/images/blog-slopes-terrain.jpg",
  "/images/guides/guide-atv-quad-towable-flail-mowers.jpg",
  "/images/guides/guide-australian-flail-mower-brands-compared.jpg",
  "/images/guides/guide-autonomous-mowing-australia-whats-next.jpg",
  "/images/guides/guide-best-all-terrain-mowers-australia.jpg",
  "/images/guides/guide-best-mower-steep-slopes.jpg",
  "/images/guides/guide-best-robot-lawn-mowers-australia.jpg",
  "/images/guides/guide-bushfire-fuel-reduction-mowing-vs-burning.jpg",
  "/images/guides/guide-cheapest-robot-mowers-australia.jpg",
  "/images/guides/guide-commercial-remote-control-mowers.jpg",
  "/images/guides/guide-commercial-robot-mowers-australia.jpg",
  "/images/guides/guide-compare-remote-controlled-mowers-australia.jpg",
  "/images/guides/guide-diy-remote-control-lawn-mower.jpg",
  "/images/guides/guide-electric-robot-remote-control-mowers.jpg",
  "/images/guides/guide-eufy-robot-mower-australia-guide.jpg",
  "/images/guides/guide-eufy-vs-roborock-robot-mower.jpg",
  "/images/guides/guide-excavator-flail-mowers-guide.jpg",
  "/images/guides/guide-flail-mower-blades-hammers-guide.jpg",
  "/images/guides/guide-flail-mower-buying-guide-australia.jpg",
  "/images/guides/guide-flail-mower-guide.jpg",
  "/images/guides/guide-flail-mower-hire-australia.jpg",
  "/images/guides/guide-flail-mower-vs-slasher-vs-mulcher.jpg",
  "/images/guides/guide-flail-mowers-for-tractors-pto-guide.jpg",
  "/images/guides/guide-flail-mowers-rough-australian-ground.jpg",
  "/images/guides/guide-gardena-robot-mower-australia-guide.jpg",
  "/images/guides/guide-hayes-flail-mowers-overview.jpg",
  "/images/guides/guide-heavy-duty-awd-robot-mowers.jpg",
  "/images/guides/guide-husqvarna-automower-australia-guide.jpg",
  "/images/guides/guide-mowing-steep-slopes-safely.jpg",
  "/images/guides/guide-orchard-vineyard-mowing-guide.jpg",
  "/images/guides/guide-planning-slope-mowing-australian-acreage.jpg",
  "/images/guides/guide-remote-control-flail-mower-guide.jpg",
  "/images/guides/guide-remote-controlled-vs-autonomous-mowers.jpg",
  "/images/guides/guide-remote-mower-planning-commercial-vegetation-work.jpg",
  "/images/guides/guide-roborock-mower-australia-guide.jpg",
  "/images/guides/guide-robot-lawn-mowers-australia-guide.jpg",
  "/images/guides/guide-robot-mower-bunnings-australia.jpg",
  "/images/guides/guide-robot-mower-comparison-australia.jpg",
  "/images/guides/guide-robot-mower-garage-storage-australia.jpg",
  "/images/guides/guide-robot-mower-prices-australia.jpg",
  "/images/guides/guide-robot-mower-vs-remote-control-mower.jpg",
  "/images/guides/guide-robot-mowers-australian-acreage-questions.jpg",
  "/images/guides/guide-robot-mowers-for-acreage.jpg",
  "/images/guides/guide-robot-reel-mowers.jpg",
  "/images/guides/guide-safe-mowing-angles-rollover-risk.jpg",
  "/images/guides/guide-second-hand-flail-mower-checklist.jpg",
  "/images/guides/guide-segway-navimow-australia-guide.jpg",
  "/images/guides/guide-segway-navimow-vs-eufy-robot-mower.jpg",
  "/images/guides/guide-segway-navimow-vs-husqvarna-automower.jpg",
  "/images/guides/guide-skid-steer-bobcat-flail-mowers.jpg",
  "/images/guides/guide-small-robot-lawn-mowers.jpg",
  "/images/guides/guide-tractor-excavator-flail-mowers-vs-self-propelled.jpg",
  "/images/guides/guide-verge-roadside-mowing-councils.jpg",
  "/images/guides/guide-where-to-buy-robot-remote-control-mowers-australia.jpg",
  "/images/guides/guide-wire-free-robot-mowers-rtk-gps.jpg",
  "/images/guides/guide-worx-landroid-australia-guide.jpg",
  "/images/pygmy-field.jpg",
  "/images/pygmy-field.webp",
  "/images/pygmy-grass.jpg",
  "/images/pygmy-grass.webp",
  "/images/pygmy-hero.jpg",
  "/images/pygmy-hero.webp"
] as const;
